"use client";

import Link from "next/link";

interface SidePanelProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SidePanel({ isOpen, onClose }: SidePanelProps) {
  return (
    <>
      <div
        className={`fixed top-0 left-0 w-full h-full bg-black/80 z-[998] transition-opacity duration-300 ${
          isOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        onClick={onClose}
      ></div>
      <div
        className={`fixed top-0 right-0 w-[80%] h-full bg-[#e4e2dd] border-l-[3px] border-[#1a1a1a] z-[999] flex flex-col p-8 transition-transform duration-300 ease-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <Link
          href="/"
          className="text-[1.5rem] mb-6 font-[family-name:var(--font-display)] uppercase border-b border-black/10 pb-2"
          onClick={onClose}
        >
          Home
        </Link>

        <Link
          href="/work"
          className="text-[1.5rem] mb-6 font-[family-name:var(--font-display)] uppercase border-b border-black/10 pb-2"
          onClick={onClose}
        >
          Work
        </Link>
        <Link
          href="/blog"
          className="text-[1.5rem] mb-6 font-[family-name:var(--font-display)] uppercase border-b border-black/10 pb-2"
          onClick={onClose}
        >
          Blog
        </Link>
        <Link href="/connect" className="btn mt-auto w-full text-center" onClick={onClose}>
          Connect
        </Link>
      </div>
    </>
  );
}
